import { render, staticRenderFns } from "./CaseQueryRecord.vue?vue&type=template&id=5703ebd4&scoped=true"
import script from "./CaseQueryRecord.vue?vue&type=script&lang=js"
export * from "./CaseQueryRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5703ebd4",
  null
  
)

export default component.exports